import { xingConnect } from "@xingternal/frame-data-provider";
import { Zerofier as ZerofierComponent } from "./zerofier";
import { zerofierSelectors } from "./zerofier.selectors";
const Zerofier = xingConnect(zerofierSelectors)(ZerofierComponent);
export {
  Zerofier
};
